import { render, staticRenderFns } from "./VisitorMain.vue?vue&type=template&id=1c01f4ca&scoped=true"
import script from "./VisitorMain.vue?vue&type=script&lang=js"
export * from "./VisitorMain.vue?vue&type=script&lang=js"
import style0 from "./VisitorMain.vue?vue&type=style&index=0&id=1c01f4ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c01f4ca",
  null
  
)

export default component.exports